<mat-card-content>
  <div formGroupName="priceInputRegistForm">
    <div class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-start tw-items-center tw-content-center">
      <mat-form-field appearance="outline"
        class="input-form tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[40%]">
        <mat-label>割引・割増開始日</mat-label>
        <input matInput [matDatepicker]="waribikiKaishiYMD" formControlName="waribikiKaishiYMD" autocomplete="off"
          required maxlength="10" />
        <mat-datepicker-toggle matSuffix [for]="waribikiKaishiYMD"></mat-datepicker-toggle>
        <mat-datepicker #waribikiKaishiYMD></mat-datepicker>
      </mat-form-field>

      <mat-form-field appearance="outline"
        class="input-form tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[40%]">
        <mat-label>割引・割増解除日</mat-label>
        <input matInput [matDatepicker]="waribikiKaijoYMD" formControlName="waribikiKaijoYMD" autocomplete="off"
          maxlength="10" />
        <mat-datepicker-toggle matSuffix [for]="waribikiKaijoYMD"></mat-datepicker-toggle>
        <mat-datepicker #waribikiKaijoYMD></mat-datepicker>
      </mat-form-field>
    </div>

    <div *ngIf="showKingaku">
      <div class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-start tw-items-center tw-content-center">
        <mat-form-field appearance="outline"
          class="input-form tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[40%]">
          <mat-label>割引・割増金額</mat-label>
          <input matInput formControlName="waribikiKingaku" autocomplete="off" class="number"
            (blur)="onBlurNumberEdit('waribikiKingaku')"
            [maxlength]="numberCommaMaxLength1" required />
          <span matSuffix class="tw-ml-[5px]">円</span>
        </mat-form-field>
      </div>
    </div>

    <div *ngIf="!showKingaku">
      <div class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-start tw-items-center tw-content-center">
        <mat-form-field appearance="outline"
          class="input-form tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[40%]">
          <mat-label>割引・割増率</mat-label>
          <input matInput formControlName="waribikiRitsu" autocomplete="off" class="number"
            (blur)="onBlurNumberComma('waribikiRitsu')" (focus)="onFocusNumberComma('waribikiRitsu')"
            [maxlength]="numberCommaMaxLength2" required />
          <span matSuffix class="tw-ml-[5px]">％</span>
        </mat-form-field>
      </div>
    </div>
  </div>

  <div class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-end tw-items-center tw-content-center">
    <mat-card-actions class="btn_area_right">
      <button type="button" mat-raised-button color="primary" class="btn" (click)="onClickOk()"
        [disabled]="parentForm.invalid || priceInputRegistForm.invalid">
        OK
      </button>
    </mat-card-actions>
    <mat-card-actions class="btn_area_right">
      <button type="button" mat-raised-button color="primary" class="btn" (click)="onClickCancel()">
        閉じる
      </button>
    </mat-card-actions>
  </div>
</mat-card-content>